import { S3Client } from "@aws-sdk/client-s3";
import { DynamoDBDocumentClient } from "@aws-sdk/lib-dynamodb";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface AwsClientState {
  docClient: DynamoDBDocumentClient | null,
  s3Client: S3Client | null
}

const initialState: AwsClientState = {
  docClient: null,
  s3Client: null
};

export const awsClient = createSlice({
  name: "awsClient",
  initialState,
  reducers: {
    setDocClient(state, action: PayloadAction<DynamoDBDocumentClient>) {
      return {
        ...state,
        docClient: action.payload,
      }
    },
    setS3Client(state, action: PayloadAction<S3Client>) {
      return {
        ...state,
        s3Client: action.payload,
      }
    }
  },
});

export const { setDocClient, setS3Client } = awsClient.actions;
export default awsClient;
